export function isOwnerOfAsset(role, rawAssetDetails, idValueMapping) {
  const hasOwnerAttribute = rawAssetDetails?.owner !== undefined;
  // NOTE: update when owner field data cleaned up
  const OWNER_DATA_INVALID = !Array.isArray(rawAssetDetails.owner);
  if (!hasOwnerAttribute) {
    return false;
  }
  let assetOwner = null;
  if (OWNER_DATA_INVALID) {
    // NOTE: handle alternative method of owner name, at least for OE demo (Steve Quinn, 4/8/2020)
    const ao = idValueMapping.find((owner) => owner._id === rawAssetDetails.owner);
    if (ao) {
      assetOwner = ao;
    } else {
      return false;
    }
  } else {
    // NOTE: one owner per asset for now
    const ownerId = rawAssetDetails.owner[0];
    assetOwner = idValueMapping.find((owner) => owner._id === ownerId);
  }
  const assetOwnerOrgId = assetOwner ? assetOwner.idm_org_id : '';
  const isOwner = role.userVaultRoles.some((vaultRole) => vaultRole.orgId === assetOwnerOrgId);
  return isOwner;
}
